import ReactCalendar, { TileDisabledFunc } from 'react-calendar';
import { useConfig } from '../../config';
import { formatCalendarDate } from '../subscriptions/utils';
import './Calendar.css';

export const isDate = (value: any) => Object.prototype.toString.call(value) === '[object Date]';

export type CalendarProps = {
	onChangeDate?: (value: Value) => void;
	minDate?: Date;
	maxDate?: Date;
	selectedDate?: string | undefined;
	checkDisabled?: TileDisabledFunc;
};

export type ValuePiece = Date | null;

export type Value = ValuePiece | [ValuePiece, ValuePiece];

export const Calendar = ({
	onChangeDate,
	minDate,
	maxDate,
	selectedDate,
	checkDisabled,
}: CalendarProps): JSX.Element => {
	// export const Calendar = ({ onChangeDate }: { onChangeDate?: (value: Date | null) => void }): JSX.Element => {
	const { locale } = useConfig();
	const onChange = (value: Value) => {
		if (isDate(value)) {
			if (onChangeDate) onChangeDate(value);
		}
	};

	const tileClassName = ({ date }: { date: Date }): string | undefined => {
		if (formatCalendarDate(date) === selectedDate) {
			return 'selected-date';
		}
	};

	return (
		<ReactCalendar
			tileDisabled={({ activeStartDate, date, view }) => {
				if (checkDisabled) return checkDisabled({ activeStartDate, date, view });

				return false;
			}}
			minDate={minDate}
			maxDate={maxDate}
			onChange={onChange}
			locale={locale}
			defaultActiveStartDate={selectedDate ? new Date(selectedDate) : undefined}
			tileClassName={tileClassName}
		/>
	);
};
